import { ClassNameMap } from "@material-ui/styles/withStyles";
import { DetailsCardProps, Typography } from "@welldigital/components";
import { ProfileTarget, UserProfileLink } from "@welldigital/ui-common";
import { goToURL } from "../../utils";

export type Classes = ClassNameMap<"cardContentText">;

export type BuildCardDataParams = {
  id: ProfileTarget;
  link: UserProfileLink;
  classes: Classes;
  updateRenderableLinks: (userProfileLinks: UserProfileLink[]) => void;
  isUsingInitialLinks: boolean;
};

export type CardData = {
  cardProps: DetailsCardProps;
  content: JSX.Element;
};

export type CardsData = Record<ProfileTarget, CardData>;

const buildCardData = ({
  classes,
  link,
  updateRenderableLinks,
  isUsingInitialLinks,
}: BuildCardDataParams): CardData => {
  return {
    cardProps: {
      title: link.label,
      icons: [
        {
          component: link.icon,
          color: "primary",
        },
      ],
      buttons: [
        {
          color: isUsingInitialLinks ? "primary" : "secondary",
          variant: "contained",
          children: isUsingInitialLinks ? "View details" : "Go to dashboard",
          onClick: link.children
            ? updateRenderableLinks.bind(null, link.children)
            : goToURL.bind(null, link.href),
          title: link.href,
        },
      ],
    },
    content: (
      <Typography className={classes.cardContentText}>
        {link.loginDescription}
      </Typography>
    ),
  };
};

export const getCardsData = (
  classes: Classes,
  availableLinks: UserProfileLink[],
  updateRenderableLinks: BuildCardDataParams["updateRenderableLinks"],
  isUsingInitialLinks: BuildCardDataParams["isUsingInitialLinks"]
): CardsData => {
  const cardsData = availableLinks.reduce((acc, link) => {
    const id = link.id as ProfileTarget;
    acc[id] = buildCardData({
      id,
      classes,
      link,
      updateRenderableLinks,
      isUsingInitialLinks,
    });
    return acc;
  }, {} as CardsData);
  return cardsData;
};
